<template>
  <div class="tree">
    <tree-node
      v-for="(node, i) in displayValue"
      :key="node.id ?? i"
      :node="node"
      :path="[i]"
    >
      <template #default="slotProps">
        <slot v-bind="slotProps"></slot>
      </template>
    </tree-node>
  </div>
</template>

<script>
import TreeNode from "./TreeNode.vue";

const withOpenedRecursive = (nodes) =>
  nodes.map((n) => ({
    ...n,
    opened: true,
    children: Array.isArray(n.children) ? withOpenedRecursive(n.children) : n.children
  }));

export default {
  name: "Tree",
  components: { TreeNode },
  props: {
    value: { type: Array, required: true },
    foldingTransition: { type: Boolean, default: true },
    autoOpenAll: { type: Boolean, default: false }
  },
  emits: ["node-folded-changed"],
  computed: {
    displayValue() {
      return this.autoOpenAll ? withOpenedRecursive(this.value) : this.value;
    }
  },
  provide() {
    return {
      onTreeToggle: (node) => {
        const wasOpen = !!node.opened;
        this.$emit("node-folded-changed", { ...node, $folded: wasOpen });
      }
    };
  }
};
</script>

<style lang="scss" scoped>
.tree {
  font-size: 0.875rem;
}
</style>
